import _extends from "@babel/runtime/helpers/extends";
import { useIsMobileDimension } from '@beef/ui-kit';
import { Button } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import React from 'react';
import { BackButton } from "../../../../HeaderButtons/BackButton/BackButton";
import { LogoButton } from "../../../../HeaderButtons/LogoButton/LogoButton";
import { ModalLayout } from "../../../../../../components/ModalLayout";
import { Title } from "../../../../../../components/Title";
import { withControlAnalytics } from "../../../../../../utils/withControlAnalytics";
import { onButtonPressAnalyticsHandler, onPhoneInputAnalyticsHandler } from "./analytics";
import { CaptchaInput } from "./components/Captcha/CaptchaInput";
import { FormLayout } from "./components/FormLayout";
import { LegalBlock } from "./components/LegalBlock";
import styles from "./styles.pcss";
import { PhoneInput } from "../../PaymentSelection/components/PaymentDetailsSection/InputSection/components/PhoneInput";
var EnhancedInput = withControlAnalytics('onBlur', onPhoneInputAnalyticsHandler)(PhoneInput);
var EnhancedButton = withControlAnalytics('onClick', onButtonPressAnalyticsHandler)(Button);
var cn = classNames.bind(styles);
export var SberPayModal = function SberPayModal(_ref) {
  var backButtonProps = _ref.backButtonProps,
    titleProps = _ref.titleProps,
    phoneInputProps = _ref.phoneInputProps,
    captchaInputProps = _ref.captchaInputProps,
    agreementText = _ref.agreementText,
    confirmationButtonProps = _ref.confirmationButtonProps;
  var isMobile = useIsMobileDimension();
  return /*#__PURE__*/React.createElement(ModalLayout, {
    className: cn('wrapper'),
    "data-t-id": "Popups-SberPayModal"
  }, /*#__PURE__*/React.createElement(ModalLayout.Header, null, /*#__PURE__*/React.createElement(BackButton, _extends({}, backButtonProps, {
    isWhite: true
  })), /*#__PURE__*/React.createElement(LogoButton, null)), /*#__PURE__*/React.createElement(ModalLayout.Content, null, /*#__PURE__*/React.createElement(Title, {
    isCentered: !isMobile,
    subtitle: titleProps.subTitle,
    title: titleProps.title
  }), /*#__PURE__*/React.createElement(FormLayout, null, /*#__PURE__*/React.createElement(FormLayout.Input, null, phoneInputProps && /*#__PURE__*/React.createElement(EnhancedInput, _extends({
    type: "text"
  }, phoneInputProps)), captchaInputProps && /*#__PURE__*/React.createElement(CaptchaInput, captchaInputProps)), /*#__PURE__*/React.createElement(FormLayout.Buttons, null, /*#__PURE__*/React.createElement(LegalBlock, {
    text: agreementText
  }, /*#__PURE__*/React.createElement(EnhancedButton, _extends({}, confirmationButtonProps, {
    size: "l",
    width: "full",
    "data-t-id": "Popups-SberPayModal"
  })))))));
};